import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import { adapi, Debug, storeGetters, initDycolor, FileUpload } from '~';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { CREATIVE_STATUSES } from '@/util/constants';

initDycolor('creative-external-previews', require(`${process.env.DYCOLOR_REQUIRE}./CreativeExternalPreviews.scss`)); // eslint-disable-line

const debug = Debug('creative-external-previews');

export default {
  components: {
    FileUpload,
    BoxWidget,
  },
  data() {
    return {
      creative: null,
    };
  },
  computed: {
    ...mapState('creative', ['current']),
    canFinishCreative() {
      return [CREATIVE_STATUSES.BRIEF, CREATIVE_STATUSES.WIP].indexOf(this.creative.status) !== -1;
    },
  },
  methods: {
    ...mapActions('creative', ['reloadCreative', 'completeCreative']),
    save(complete) {
      adapi.patch(`creatives/${storeGetters.getRouterParams().id}/updateExternal`, null, {
        previews: this.creative.external_previews,
      })
      .then(result => {
        debug.info('success', result);
        this.$toast.success({ message: this.$t('pos.campaign.creatives.external_previews.updated') });
        if (complete) {
          this.completeCreative({
            id: storeGetters.getRouterParams().id,
            body: { forceToStatus: CREATIVE_STATUSES.READY },
          })
            .then(() => this.$toast.success({ message: this.$t('pos.campaign.creatives.external_previews.complete') }));
        }
      })
      .then(() => this.reloadCreative())
      .catch(error => {
        this.$toast.error({ message: adapi.translateAdapiErrors(error.errors, this.$t) });
      });
    },
    updateExternalPreviewsFiles(data) {
      this.creative.external_previews = data;
    },
  },
  watch: {
    current: {
      deep: true,
      immediate: true,
      handler: function watchCurrent(creative) {
        // Update data every time Creative store value updates
        const copy = _.cloneDeep(creative);
        copy.external_previews.forEach(preview => {
          preview.size = preview.file_size;
          preview.name = preview.file_name;
        });
        this.creative = copy;
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/lab/creative-external-previews/CreativeExternalPreviews.js